import { ColumnDef } from '@tanstack/react-table';

import { IPaginationTable } from '../common/interfaces/IPaginationTable';

import Table from '@/components/table/common/Table';
import { ICollectionPrompt } from '@/interfaces/api/ICollectionPrompt';
import { ICollection } from '@/interfaces/api/collection/ICollection';
import { IPromptWithAction } from '@/interfaces/api/prompt/IPromptWithAction';

const PromptTable = ({
	collectionPrompt,
	paginationOption,
	columns,
}: {
	collectionPrompt: ICollectionPrompt;
	paginationOption: IPaginationTable;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	columns: ColumnDef<IPromptWithAction, any>[];
}) => {
	const handleCollectionWithAction = (
		collection: ICollectionPrompt,
	): ICollection<IPromptWithAction> => {
		return {
			...collection,
			data: collection.data.map((item) => ({
				...item,
				action: '',
			})),
		};
	};

	return (
		<div
			className="flex flex-col items-center border-t border-gray-300 w-full bg-grey-0 border border-gray-300 rounded-md px-[2rem]"
			data-test="stores-dashboard"
		>
			<h3 className="text-grey-50 text-md leading-5 font-medium py-2">
				Prompts List
			</h3>

			<Table<IPromptWithAction>
				collection={handleCollectionWithAction(collectionPrompt)}
				columns={columns}
				paginationSection={paginationOption}
				tableStyles={{
					tableBox: 'w-full overflow-y-auto h-48',
					table: 'w-full',
				}}
				dataTest="prompts-table"
			/>
		</div>
	);
};

export default PromptTable;
